<template>
  <div class="share-footer">
    <div class="share-list" v-for="item in list" :key="item.name" @click="handleShare(item)">
      <img :src="item.icon" alt="" />
      <div class="name">{{ item.name }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        {
          name: "抖音",
          icon: require("@/assets/images/tiktok-logo.png"),
          source: "douyin"
        },
        {
          name: "B站",
          icon: require("@/assets/images/bilibili-logo.png"),
          source: "bilibili"
        },
        {
          name: "微信",
          icon: require("@/assets/images/wechat-logo.png"),
          source: "wechat"
        },
        {
          name: "小红书",
          icon: require("@/assets/images/red-book-logo.png"),
          source: "xiaohongshu"
        },
        {
          name: "QQ",
          icon: require("@/assets/images/qq-logo.png"),
          source: "qq"
        }
      ]
    };
  },
  methods: {
    handleShare(item) {
      const copyText = window.location.origin + window.location.pathname + "?webSource=" + item.source;
      const input = document.createElement("input");
      input.setAttribute("value", copyText);
      document.body.appendChild(input);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$message.success("复制成功");
      }
      document.body.removeChild(input);
    }
  }
};
</script>
<style scoped lang="less">
.share-footer {
  position: absolute;
  left: 0;
  bottom: -180px;
  width: 427px;
  height: 87px;
  background: #f1f5fd;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-around;

  .share-list {
    width: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    img {
      width: 40px;
      height: 40px;
      margin-bottom: 5px;
    }

    .name {
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 18px;
      font-weight: 400;
      font-size: 13px;
      color: #333333;
    }
  }
}
</style>
